/**
 * Removes the legacy section marker the checklist editor stores in section titles.
 * `_#SEC#` is removed first because it contains `#SEC#`.
 */
export function stripChecklistSectionMarker(
  title: string | null | undefined
): string {
  if (typeof title !== 'string') {
    return '';
  }
  return title.replace('_#SEC#', '').replace('#SEC#', '');
}
